// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UsFTj","title":"styles_title__oZnMj","text":"styles_text__pVEIf","participateContainer":"styles_participateContainer__SNQnu"};